/** Max length for app_bundle_id (Android package / DB column, DAI-1225). */
export const MAX_APP_BUNDLE_ID_LENGTH = 255;

/**
 * Package / reverse-DNS — aligned with BA-API-Handler / buyer-journal, plus
 * hyphen (DAI-1222). Case-insensitive; segments may start with a digit.
 * Deliberately not the Android-compiler ruleset: real DB bundles use
 * uppercase and reserved-word segments.
 */
const PACKAGE_RE = /^[a-zA-Z0-9_-]+\.[a-zA-Z0-9_.-]+$/;

/** iOS numeric App Store id — 6–20 digits (same as BA-API-Handler). */
const IOS_BUNDLE_RE = /^\d{6,20}$/;

export type AppBundleIdValidation =
	| { ok: true }
	| { ok: false; message: string };

/**
 * Validate social-casino `app_bundle_id` before Add / Save (DAI-1222/1225).
 *
 * Accepts:
 * - package / reverse-DNS: `com.example.app`, `com.Gratitude3.app`, `com.app.coach-log`
 * - iOS id: 6–20 digits
 */
export function validateAppBundleId(value: string): AppBundleIdValidation {
	const cleaned = value.trim();
	if (!cleaned) {
		return { ok: false, message: "Вкажіть `app_bundle_id`" };
	}

	if (cleaned.length > MAX_APP_BUNDLE_ID_LENGTH) {
		return {
			ok: false,
			message: `\`app_bundle_id\` не може бути довшим за ${MAX_APP_BUNDLE_ID_LENGTH} символів`,
		};
	}

	if (IOS_BUNDLE_RE.test(cleaned)) {
		return { ok: true };
	}

	if (!PACKAGE_RE.test(cleaned)) {
		return {
			ok: false,
			message:
				"`app_bundle_id` має бути package name (напр. com.example.app або com.app.coach-log) або iOS id (6–20 цифр)",
		};
	}

	return { ok: true };
}

export function isValidAppBundleId(value: string): boolean {
	return validateAppBundleId(value).ok;
}
